import { FirestoreCollections } from '@griply/types';

import {
  FirestoreInstance,
  OrderByDirection,
  WhereFilterOp,
} from '../types/firestore';

export type GetSmartListsQueryOptions<
  TCollection = unknown,
  TQuery = unknown,
  TConstraint = unknown,
  TDb = FirestoreInstance,
> = {
  db: TDb;
  collection: (
    db: NoInfer<TDb>,
    path: string,
    ...rest: string[]
  ) => TCollection;
  query: (ref: TCollection, ...constraints: TConstraint[]) => TQuery;
  where: (field: string, op: WhereFilterOp, value: unknown) => TConstraint;
  orderBy: (field: string, direction?: OrderByDirection) => TConstraint;
  userId: string;
};

export const getSmartListsQuery = <
  TCollection,
  TQuery,
  TConstraint,
  TDb = FirestoreInstance,
>(
  options: GetSmartListsQueryOptions<TCollection, TQuery, TConstraint, TDb>,
): TQuery => {
  const { db, collection, query, where, orderBy, userId } = options;

  return query(
    collection(db, FirestoreCollections.SmartLists),
    where('roles.all', 'array-contains', userId),
    orderBy('createdAt', 'asc'),
  );
};
